import floatToEndingNine from '@/composables/floatToEndingNine'
import floatRoundDown from '@/composables/floatRoundDown'

const getPricePerIntervalLength = (amount: string, intervalLength: number): string => {
  if (intervalLength !== 1) {
    // only perform the math if the interval length isn't 1
    amount = floatToEndingNine(floatRoundDown(Number(amount) / intervalLength)).toFixed(2)
  }
  return amount
}

export { getPricePerIntervalLength }
